export default __webpack_public_path__ + "static/media/inabit-service.646308bf.svg";